document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".consultation-tabs-wrapper").forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll(".consultation-tab-title");
    const contents = wrapper.querySelectorAll(".consultation-tab-content");

    const initializeSwiper = (swiperContainer) => {
      if (
        swiperContainer &&
        !swiperContainer.classList.contains("swiper-initialized")
      ) {
        const settings = JSON.parse(swiperContainer.dataset.settings || "{}");

        new Swiper(swiperContainer, {
          loop: settings.loop || false,
          speed: settings.speed || 3000,
          spaceBetween: settings.spaceBetween || 30,
          autoplay: {
            delay: settings.speed || 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          simulateTouch: true,
          grabCursor: true,
          pagination: {
            el: swiperContainer.querySelector(".swiper-pagination"),
            clickable: true
          },
          breakpoints: {
            0: {
              slidesPerView: settings.mobile || 1
            },
            768: {
              slidesPerView: settings.tablet || 2
            },
            1024: {
              slidesPerView: settings.desktop || 3
            }
          }
        });

        swiperContainer.classList.add("swiper-initialized");
      }
    };

    const activeContent = wrapper.querySelector(
      ".consultation-tab-content.active"
    );
    if (activeContent) {
      const swiperContainer = activeContent.querySelector(
        ".rb-consultation-swiper"
      );
      initializeSwiper(swiperContainer);
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        tab.classList.add("active");

        const tabId = tab.getAttribute("data-tab");
        const target = wrapper.querySelector("#" + tabId);
        if (target) {
          target.classList.add("active");
          const swiperContainer = target.querySelector(
            ".rb-consultation-swiper"
          );
          initializeSwiper(swiperContainer);
        }
      });
    });
  });
});
